import { IsNotEmpty, IsString, MaxLength, IsBoolean, IsOptional, IsArray, MinLength } from 'class-validator';

export class MessageEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(100)
    title: string;

    @IsNotEmpty()
    @IsString()
    content: string;

    @IsNotEmpty()
    @IsBoolean()
    commentsEnabled: boolean;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    teams: Array<string>;

}
